export const deviceMetrics = {
  water_changes_count: 'Water Changes Count',
  avg_mopping_time_btw_water_changes: 'Avg. Mopping Time between Water Changes',
  mopping_time: 'Total Mopping Time',
  device_activity: 'Total Device Activity',
};

export const deviceMetricsColors = {
  water_changes_count: '#0EB0D8',
  avg_mopping_time_btw_water_changes: '#910ED8',
  mopping_time: '#599BFF',
  device_activity: '#2A57C7',
};

export const comparedTextToPeriod = {
  day: '(compared to previous day)',
  week: '(compared to previous week)',
  month: '(compared to previous month)',
};

export const deviceMetricsShorten = {
  water_changes_count: 'Water Changes Count',
  avg_mopping_time_btw_water_changes: 'Avg. Mopping Time',
  mopping_time: 'Total Mopping Time',
  device_activity: 'Total Device Activity',
};

export const timelapse = {
  day: 'Last 10 days',
  week: 'Last 10 weeks',
  month: 'Last 10 months',
};

export const summaryTitle = {
  day: 'Daily Summary',
  week: 'Weekly Summary',
  month: 'Monthly Summary',
};

export const deviceActivityTitle = {
  day: 'Device Activity by Day',
  week: 'Device Activity by Day',
  month: 'Device Activity by Week',
};
